import { css } from '@emotion/core';
import { media } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
export var propertyTypeButton = /*#__PURE__*/css(designTokenFonts.mini, ";padding:10px 8px;white-space:nowrap;width:100%;", media('>=tablet'), "{width:fit-content;}");
export var icon = {
  name: "1xp7lvz",
  styles: "width:18px;height:18px;margin-right:-6px;"
};